import { Application } from '@enums/application.enums';
import { AIGenerateConsts } from '@components/text-editor/ai-generate-modal/constants';

export const FREE_FORM_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'free-form-layout',
  LAYOUT_LABEL: 'Free Form Layout',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1785501130622.png',
  LAYOUT_DESCRIPTION:
    'Free-form rich text section with the article text editor',
  DATA_KEY_CONTENT: 'content',
  PLACEHOLDER_CONTENT: 'Write some text...',
  EMPTY_CONTENT_PLACEHOLDER: 'Start writing in the editor to preview this section',
  BACKGROUND_IMAGE_ALT: 'Free form section background',
  GENERATE_TYPE: Application.Article,
  AI_HEADER_LABEL: AIGenerateConsts.GenerateWithAI,
  AI_SECTION_TITLE: AIGenerateConsts.GeneratedContentPreview,
  AI_SECTION_SUBTITLE: AIGenerateConsts.GeneratedContentPreviewNote,
  SHOW_AI_HEADING_CHECKBOX: false,
  SHOW_AI_PREVIEW_IMAGE_CHECKBOX: false
} as const;
